import CustomCheckbox from '../common/CustomeCheckbox';

export default function ProducersSection({handleCheckAll, selectAllProducerCheckboxValue, producerCheckboxValues,
    toggleDropdown, handleCheck, handleCheckProducerLease, showAddCoordinateDropdown,
  }) {
    return (
        <div style={{ 'marginTop': 10, width: '93%', 'marginLeft': 10, backgroundColor: '#f5dfc1', borderWidth: 1, borderColor: '#dcb681', height: "47%" }}>
            <h2 style={{ 'marginLeft': '5px' }}>
                <strong>Producers</strong>
            </h2>
            <div style={{ 'margin': '0px 10px 10px', 'height': showAddCoordinateDropdown ? '75%' : '80%', 'overflowY': 'scroll' }}>
                <label>
                    <input
                        type="checkbox"
                        onChange={(value) => handleCheckAll(value, 'producer')}
                        checked={selectAllProducerCheckboxValue}
                    />
                    <span style={{ 'marginLeft': 5 }}>Select All</span>
                </label>
                {
                    producerCheckboxValues.map((producerCheckboxValue, index) => (
                        <CustomCheckbox 
                            key={index}
                            index={index} 
                            entityCheckboxValue={producerCheckboxValue} 
                            toggleDropdown={toggleDropdown} 
                            handleCheck={(value, index) => handleCheck(value, index, 'producer')} 
                            handleCheckSingleEntity={(value, index, singleIndex) => handleCheckProducerLease(value, index, singleIndex, 'producer')}
                        />
                    ))
                }
            </div>
        </div>
    )
}